export default class ClubMemberAccessMediumIntraKey {
    static fromData(data) {
        if (!data) {
            return;
        }

        let clubMemberAccessMedium = new ClubMemberAccessMediumIntraKey();
        clubMemberAccessMedium.id = data.id;
        clubMemberAccessMedium.accessMediumType = data.accessMediumType;
        clubMemberAccessMedium.identifier = data.identifier;
        clubMemberAccessMedium.validUntil = data.validUntil;
        clubMemberAccessMedium.permission = data.permission;
        clubMemberAccessMedium.isEditable = data.isEditable;
        clubMemberAccessMedium.isDeletable = data.isDeletable;

        Object.seal(clubMemberAccessMedium);
        return clubMemberAccessMedium;
    }

    isValid() {
        return this.identifier.length > 0 && this.accessMediumType !== undefined;
    }
}
